import type { CnFunction } from 'cn'

import { createCn } from 'cn/config'

/**
 * Utility function to merge class names with Tailwind CSS
 * Joins conditional classes and resolves conflicting Tailwind utilities
 */
export const cn: CnFunction = createCn({
  extend: {
    classGroups: {
      // Custom text scale single-sourced from @repo/tailwind-config theme-base.css
      // (--text-* tokens). Registered here so conflicting font-size utilities dedupe.
      'font-size': [
        {
          text: [
            '4xs',
            '3xs',
            '2xs',
            'xs',
            'sm',
            'base',
            'md',
            'lg',
            'xl',
            'title-xs',
            'title-sm',
            'title-md',
            'title-lg',
            'title-xl',
            'label-m',
            'label-s'
          ]
        }
      ],
      'font-family': [{ font: ['sans', 'semimono'] }]
    },
    // Custom theme values from tailwind.css @theme imports.
    theme: {
      spacing: ['2xs', 'xs', 'sm', 'md', 'lg', 'xl'],
      radius: ['xs', 'sm', 'md', 'lg']
    }
  }
})
